const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";

let googleMapsLoaded: Promise<void> | null = null;

/**
 * Shared singleton loader for Google Maps JS API.
 * Loads maps, marker, and places libraries in one call.
 * Uses the v2 top-level `setOptions` + `importLibrary` API.
 * Resets on failure so the next caller can retry.
 */
export function loadGoogleMaps(): Promise<void> {
  if (googleMapsLoaded) return googleMapsLoaded;

  googleMapsLoaded = (async () => {
    const { setOptions, importLibrary } =
      await import("@googlemaps/js-api-loader");
    setOptions({ key: API_KEY });
    await Promise.all([
      importLibrary("maps"),
      importLibrary("marker"),
      importLibrary("places"),
      importLibrary("geocoding"),
    ]);
  })().catch((err) => {
    googleMapsLoaded = null;
    throw err;
  });

  return googleMapsLoaded;
}

export { API_KEY };
